import styled from 'styled-components';

/**
 * In the trend's colour, which its icon inherits. The reset gives every svg the contrast text
 * colour, and that rule outranks the icon's own `color` prop, which is only an attribute.
 */
export const StyledTrendIcon = styled.span<{ $color: string | undefined }>`
  display: inline-flex;
  color: ${({ $color }) => $color ?? 'inherit'};

  svg {
    color: inherit;
  }
`;
